import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../components/Admin/Drawer";
import Bio from "./Bio";
import { BioProvider } from "../../../components/Bio/BioContext";
import { useStyles, theme } from "../theme.js";

const BioAdminPage = (props) => {
  const classes = useStyles();

  return (
    <BioProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Bio></Bio>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </BioProvider>
  );
};

export default BioAdminPage;
